/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Legal_Property_DetailsInputs */

const cs_property_legal_property_details = /** @type {(inputs: Property_Legal_Property_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detaily nemovitosti`)
};

const en_property_legal_property_details = /** @type {(inputs: Property_Legal_Property_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Property details`)
};

/**
* | output |
* | --- |
* | "Property details" |
*
* @param {Property_Legal_Property_DetailsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_legal_property_details = /** @type {((inputs?: Property_Legal_Property_DetailsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Legal_Property_DetailsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_legal_property_details(inputs)
	return cs_property_legal_property_details(inputs)
});